import React from 'react'
import Dropdown from 'components/ui/Dropdown'
import EllipsisButton from './EllipsisButton'
import { HiDotsVertical } from 'react-icons/hi'

export const stickyActionTableClassName =
    'table-sticky-action table-freeze-first-four'
export const stickyActionHeaderClassName =
    'row-action-column row-action-header'
export const stickyActionCellClassName = 'row-action-column'

const RowActionMenu = ({
    actions = [],
    ariaLabel = 'Open row actions',
    disabled = false,
}) => {
    const availableActions = actions.filter((action) => !action.hidden)

    return (
        <Dropdown
            placement="middle-end-top"
            toggleClassName="row-action-toggle"
            renderTitle={
                <EllipsisButton
                    aria-label={ariaLabel}
                    title={ariaLabel}
                    icon={<HiDotsVertical className="text-lg" />}
                    className="row-action-trigger"
                    disabled={disabled}
                />
            }
            menuClass="row-action-menu"
        >
            {availableActions.length ? (
                availableActions.map((action) => (
                    <Dropdown.Item
                        key={action.key || action.label}
                        disabled={action.disabled}
                        className={action.className}
                        onClick={(event) => {
                            event.stopPropagation()
                            action.onClick?.()
                        }}
                    >
                        <span className="flex items-center gap-2">
                            {action.icon}
                            <span>{action.label}</span>
                        </span>
                    </Dropdown.Item>
                ))
            ) : (
                <Dropdown.Item disabled>No actions</Dropdown.Item>
            )}
        </Dropdown>
    )
}

export default RowActionMenu
